import React from "react";
import { Panel } from "@/components/common/Panel";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { GitBranch, Sparkles, FileText, Gavel, Users, BookOpen, Scale, ScrollText, AlertTriangle } from "lucide-react";
import { AnimationFrame } from "@/components/common/AnimationFrame";

const SOURCES = [["Case record (Case Passport)", Scale], ["Pleadings", FileText], ["Documents & evidence", FileText], ["Orders", ScrollText], ["Hearings", Gavel], ["Parties / witness material", Users], ["Verified authorities", BookOpen]];

export function BuildEmptyState({ run, onAnalyse, onManual }) {
  const running = run && ["QUEUED", "PROCESSING", "VERIFYING"].includes(run.status);
  const failed = run?.status === "FAILED";
  return (
    <Panel className="flex flex-col items-center p-10 text-center" data-testid="pg-empty">
      <div className={cn("flex h-14 w-14 items-center justify-center rounded-full bg-copper-light", running && "animate-pulse")}><GitBranch className="h-7 w-7 text-copper" /></div>
      <h3 className="mt-4 font-display text-2xl font-semibold text-ink">Build this matter’s ProofGraph</h3>
      <p className="mt-1 max-w-lg text-sm text-ink-2">Nyayyaksha will map the current issues, claims, defences, reliefs, verified facts and evidence into a reviewable proof structure. Every proposal stays <b>Proposed</b> until you accept it.</p>
      <div className="mt-5 grid grid-cols-2 gap-2 text-left text-xs text-ink-2 sm:grid-cols-4">
        {SOURCES.map(([l, I]) => <div key={l} className="flex items-center gap-2 rounded-lg border border-line bg-surface px-2.5 py-1.5"><I className="h-3.5 w-3.5 text-copper" />{l}</div>)}
      </div>
      {running ? (
        <div className="mt-6 flex flex-col items-center gap-2" data-testid="pg-run-stage">
          <AnimationFrame slug="title-tree" title="Growing the proof structure" height={220} maxWidth={360} />
          <div className="flex items-center gap-2 text-sm font-medium text-copper"><Sparkles className="h-4 w-4 animate-pulse" /> {run.stage}</div>
        </div>
      ) : (
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <Button onClick={onAnalyse} data-testid="pg-analyse-btn"><Sparkles className="mr-2 h-4 w-4" /> Analyse Matter</Button>
          <Button variant="outline" onClick={onManual} data-testid="pg-manual-btn">Build Manually</Button>
        </div>
      )}
      {failed && <div className="mt-3 flex items-center gap-2 rounded-lg bg-danger-bg px-3 py-2 text-xs text-danger" data-testid="pg-run-error"><AlertTriangle className="h-4 w-4" /> Analysis failed: {run.error || "unknown error"}. The matter record is untouched — you can retry.</div>}
    </Panel>
  );
}
